import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

/* MODELS

Video = {
    "id": 1,
    "uuid": "uuid",
    "title": "title",
    "description": "description",
    "author": "author",
    "thumbnail": "/path/to/thumbnail",
    "type": "vod",
    "sourcePath": "/path/to/source/video",
    "encodedPath": "/path/to/encoded/video",
    "encodingStatus": "to_encode",
    "createdAt": "2018-04-19T08:53:15.000Z",
    "updatedAt": "2018-04-19T08:53:15.000Z",
    "client_id": 1,
    "user_id": 1
}

VideoRegisterForm = {
    "title": "Video title",
    "description": "Video description",
    "author": "Video author",
    "type": "vod"
    "url": "http://example.com/url.html", ==> If type = live
    "video": file, ==> If type = vod
}

VideoPut = {
    "title": "Title",
    "description": "Description",
    "author": "Author"
}

Representation: [
    {
        "id": 1,
        "fps": 30,
        "segmentDuration": 6,
        "gopSize": 4,
        "video_id": 1,
        "options": "",
        "Resolutions": [
            {
                "id": 1,
                "width": 1920,
                "height": 1080,
                "representation_id": 1,
                "Bitrates": [
                    {
                        "id": 1,
                        "bitrate": 1200,
                        "resolution_id": 1
                    },
                    {
                        "id": 2,
                        "bitrate": 2100,
                        "resolution_id": 1
                    }
                ]
            }
        ]
    }
]

RepresentationRegister = {
    "fps": 30,
    "segmentDuration": 6,
    "gopSize": 4,
        "options": "",
    "resolutions": [
        {
            "width": 1920,
            "height": 1080,
            "bitrates": [1200, 2100]
        }
    ]
}

*/


/**
 * Implements Categories endpoints from https://github.com/dngroup/msstream-platform/wiki/Upload-Manager-API#videos
 */
export default class VideoService {

    /**
     * Upload a new video. It requires 'Administrator' or 'Manage videos' privilege. The type can be set to "live" or "vod".
     * 
     * @param {VideoRegisterFormData} video 
     * @return {Video}
     */
    postVideo(video, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videos',
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Basic ' + token
                },
                data: video
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Upload videos. It requires 'Administrator' or 'Manage videos' privilege. The type can be set to "live" or "vod".
     * 
     * @param {VideoRegisterFormData} video 
     * @return {Video}
     */
    postVideoJson(videos, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videos',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: videos
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Upload videos. It requires 'Administrator' or 'Manage videos' privilege. The type can be set to "live" or "vod".
     * 
     * @param {VideoRegisterFormData} video 
     * @return {Video}
     */
    postVideos(videos, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videos/multiple',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: videos
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postChunk(uuid, chunk, data, filename, isEnd, token) {
        var formData = new FormData();
        formData.append('video', data, filename);
        if (isEnd) {
            formData.append('end', 'true');
        }
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${uuid}/${chunk}`,
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Basic ' + token
                },
                data: formData
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get all videos for the client.
     * 
     * @param {string} token 
     * @return {[Video]}
     */
    getVideosForClient(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videos',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get all videos for the client. with pagination
     * 
     * @param {string} token 
     * @return {[Video]}
     */
    getVideosPageForClient(token, pagination) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videos',
                method: 'get',
                params: pagination,
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getVideoListPlugin(token,data)
    {
      return new Promise((done, reject) => {
        var instance = {
          baseURL: base + '/api/videosplugin',
          method: 'get',
          params: data,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + token
          },
        };
        axios(instance).then((response) => {
          done(response.data);
        }).catch((error) => {
          reject(error);
        })
      });
    }

    refreshVideoPlugin(token, params)
    {
      return new Promise((done, reject) => {
        var instance = {
          baseURL: base + '/api/refreshvideosplugin',
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + token
          },
          params:params
        };
        axios(instance).then((response) => {
          done();
        }).catch((error) => {
          reject(error);
        })
      });
    }

    

    /**
     * Get video with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
    getVideoById(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get live stats with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
     getLiveStats(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/live/stats/${videoId}`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get live stats with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
     getExternalStreamsStats(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/externalstreams/stats`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Start external streams.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
     putExternalStreamsStart(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/externalstreams/start`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }
    
    
    /**
     * Start external streams.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
     putExternalStreamsStop(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/externalstreams/stop`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get live stats with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
     putExternalStreams(videoId, externalStreams, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/externalstreams`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                data: {
                    externalStreams: externalStreams
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get video player with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
    getVideoPlayerById(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/player`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update video with the the given {videoId}. Requires 'Administrator' or 'Manage videos' privilege.
     * 
     * @param {VideoRegisterPut} video
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
    putVideoById(video, videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: video
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

        /**
     * Update plugin video with the the given {videoId}.
     * 
     * @param {VideoRegisterPut} video
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
         putVideoPluginById(video, videoId, token) {
            return new Promise((done, reject) => {
                var instance = {
                    baseURL: base + `/api/videosplugin/${videoId}`,
                    method: 'put',
                    headers: {
                        'Authorization': 'Basic ' + token,
                        'Content-Type': 'application/json',
                    },
                    data: video
                };
                axios(instance).then((response) => {
                    done(response.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        }
    /**
     * Update plugin video with the the given {videoId}.
     * 
     * @param {VideoRegisterPut} video
     * @param {string} collection 
     * @param {string} token 
     * @return {Video}
     */
    putVideoPluginByCollection(video, collection, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videosplugin/collection/${collection}`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: video
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update video with the the given {videoId}. Requires 'Administrator' or 'Manage videos' privilege.
     * 
     * @param {VideoRegisterPut} video
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
     putVideoDownload(download, videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/download`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: {
                    download: download
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
 * Update video with the the given {videoId}. Requires 'Administrator' or 'Manage videos' privilege.
 * 
 * @param {VideoRegisterPut} video
 * @param {string} videoId 
 * @param {string} token 
 * @return {Video}
 */
    putVideoAdmin(video, videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videosadmin/${videoId}`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: video
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get video duration
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {any}
     */
    getVideoDuration(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/duration`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update video with the the given {videoId}. Requires 'Administrator' or 'Manage videos' privilege.
     * 
     * @param {VideoRegisterPut} chapters
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
    putChapters(chapters, videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/chapters`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: chapters
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update video with the the given {videoId}. Requires 'Administrator' or 'Manage videos' privilege.
     * 
     * @param {VideoRegisterPut} chapters
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
    putChaptersFile(videoId, form, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/chaptersfile`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: form
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get list of available representations for video with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Representation}
     */
    getRepresentationsFromVideoById(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/representations`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update list of available representations for video with the given {videoId}.
     * 
     * @param {RepresentationRegister} representation
     * @param {string} videoId 
     * @param {string} token 
     * @return {Representation}
     */
    putRepresentationsToVideoById(representation, videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/representations`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: representation
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Start encoding video with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {}
     */
    putEncodingToVideoById(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/encoding`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                }
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Stop encoding video with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {}
     */
    deleteEncodingToVideoById(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/encoding`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Add the video with the given {videoId} to the category with the given {categoryId}.
     * 
     * @param {string} videoId 
     * @param {string} categoryId 
     * @param {string} token 
     * @return {}
     */
    putVideoToCategoryByIds(videoId, categoryId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/categories/${categoryId}`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Remove the video with the given {videoId} from the category with the given {categoryId}.
     * 
     * @param {string} videoId 
     * @param {string} categoryId 
     * @param {string} token 
     * @return {}
     */
    deleteVideoFromCategoryByIds(videoId, categoryId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/categories/${categoryId}`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Delete video with the the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} categoryId 
     * @param {string} token 
     * @return {}
     */
    deleteVideoById(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get the video manifest with the given {videoIs} 
     * @param {string} videoId 
     * @param {string} token 
     * @returns 
     */
    getVideoManifest(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/manifest`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    failedUpload(token, videosId) {

        videosId = JSON.stringify(videosId);

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videosFailedUpload`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'

                },
                data: videosId
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    generateThumbnailByTime(token, uuid, time)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/customThumbnail/${uuid}/time/${time}`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    uploadThumbnail(token, uuid, thumbnail)
    {
        let formData = new FormData()
        if (thumbnail && thumbnail.name) {
            formData.append('thumbnail', thumbnail, thumbnail.name)
        } else {
            formData.append('thumbnail', thumbnail, "thumbnail.jpg")
        }

        console.log(formData)
        
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/customThumbnail/${uuid}`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'multipart/form-data'

                },
                data: formData
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    removeThumbnail(token, uuid)
    {
       
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/customThumbnail/${uuid}`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,

                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putInAndOut(inAndOut, videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/inAndOut`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: inAndOut
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postInAndOutTask(inAndOut, videoId, token)
    {
        var data = {
            uuid: videoId,
            start: inAndOut.start,
            end: inAndOut.end,
            transcode: (inAndOut.transcode === true)
        }

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/tasks/in_out`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putVodToLive(startDate, videoId, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/vodToLive`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: startDate
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteVodToLive(videoId, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/vodToLive`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteProgrammed(deleteDate, videoId, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/programmed`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: {
                    deleteDate: deleteDate
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteVideoIfUploading(videoId, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}/uploading`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postVodToLiveTask(startDate, videoId, token)
    {
        var data = {
            uuid:videoId,
            startDate:startDate,
        }

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/tasks/vod2live`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putVideoAccelerate(videoId, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/` + videoId + `/accelerate`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteVideoAccelerate(videoId, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/` + videoId + `/accelerate`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getVideoCloudflares(videoId, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/` + videoId + `/cloudflares`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postDownloadMpd(videoId, data, token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/` + videoId + `/download/mpd`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getClientTags(token, client)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/tags`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                params: {
                    client: client
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getClientCollections(token, client)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/collections`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                params: {
                    client: client
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postOutro(videoId, form, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/outro/${videoId}`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: form
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Upload videos. It requires 'Administrator' or 'Manage videos' privilege. The type can be set to "live" or "vod".
     * 
     * @param {VideoRegisterFormData} video 
     * @return {Video}
     */
     putReplaceVideo(videoID, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/replacevideo/' + videoID,
                method: 'put',
                headers: {
                    
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Refresh encoders
     * 
     * 
     */
     postRefresh(token) {
        return new Promise((done, reject) => {
            var instance = {
                url: base + '/api/refresh',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                data: {}
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }
}